import { gql } from '@apollo/client';

export const GET_MUTUAL_FUND_FILTERS = gql`
  query getMutualFundFilters {
    getMutualFundFilters {
      fundCategories
      investmentStyles
    }
  }
`;
